function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "flow");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "DraftIcons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-256.000000, -74.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(257.000000, 75.361590)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.80952381,0 L36.1904762,0 C38.2944181,0 40,1.70558191 40,3.80952381 L40,41.9047619 C40,44.0087038 38.2944181,45.7142857 36.1904762,45.7142857 L3.80952381,45.7142857 C1.70558191,45.7142857 0,44.0087038 0,41.9047619 L0,3.80952381 C0,1.70558191 1.70558191,0 3.80952381,0 Z",
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 1.9047619
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3809524,10.4761905 C15.9654802,11.3924264 20.4099247,13.2971883 25.7142857,16.1904762 C36.1904762,21.9047619 29.5238095,29.5238095 22.8571429,32.3809524 C18.4126984,34.2857143 14.9206349,35.2380952 12.3809524,35.2380952",
  id: "Line",
  stroke: "#3EC0AD",
  strokeWidth: 1.9047619,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(3.809524, 2.857143)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 5.71428571,
  cy: 6.66666667,
  r: 5.71428571
}), /*#__PURE__*/React.createElement("text", {
  id: 1,
  fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
  fontSize: 9.52380952,
  fontWeight: "bold",
  fill: "#FF6955"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 2.85714286,
  y: 9
}, "1"))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(24.761905, 16.190476)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 5.71428571,
  cy: 6.66666667,
  r: 5.71428571
}), /*#__PURE__*/React.createElement("text", {
  id: 2,
  fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
  fontSize: 9.52380952,
  fontWeight: "bold",
  fill: "#FF6955"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 2.85714286,
  y: 9
}, "2"))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(5.714286, 30.095238)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 5.71428571,
  cy: 6.0952381,
  r: 5.71428571
}), /*#__PURE__*/React.createElement("text", {
  id: 3,
  fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
  fontSize: 9.52380952,
  fontWeight: "bold",
  fill: "#FF6955"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 2.85714286,
  y: 9
}, "3"))))));

function SvgFlow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "49px",
    viewBox: "0 0 42 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDJweCIgaGVpZ2h0PSI0OXB4IiB2aWV3Qm94PSIwIDAgNDIgNDkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+ZmxvdzwvdGl0bGU+CiAgICA8ZyBpZD0iRHJhZnRJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRlc2t0b3AtSEQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNTYuMDAwMDAwLCAtNzQuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNTcuMDAwMDAwLCA3NS4zNjE1OTApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zLjgwOTUyMzgxLDAgTDM2LjE5MDQ3NjIsMCBDMzguMjk0NDE4MSwwIDQwLDEuNzA1NTgxOTEgNDAsMy44MDk1MjM4MSBMNDAsNDEuOTA0NzYxOSBDNDAsNDQuMDA4NzAzOCAzOC4yOTQ0MTgxLDQ1LjcxNDI4NTcgMzYuMTkwNDc2Miw0NS43MTQyODU3IEwzLjgwOTUyMzgxLDQ1LjcxNDI4NTcgQzEuNzA1NTgxOTEsNDUuNzE0Mjg1NyAwLDQ0LjAwODcwMzggMCw0MS45MDQ3NjE5IEwwLDMuODA5NTIzODEgQzAsMS43MDU1ODE5MSAxLjcwNTU4MTkxLDAgMy44MDk1MjM4MSwwIFoiIGlkPSJSZWN0YW5nbGUiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIxLjkwNDc2MTkiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi4zODA5NTI0LDEwLjQ3NjE5MDUgQzE1Ljk2NTQ4MDIsMTEuMzkyNDI2NCAyMC40MDk5MjQ3LDEzLjI5NzE4ODMgMjUuNzE0Mjg1NywxNi4xOTA0NzYyIEMzNi4xOTA0NzYyLDIxLjkwNDc2MTkgMjkuNTIzODA5NSwyOS41MjM4MDk1IDIyLjg1NzE0MjksMzIuMzgwOTUyNCBDMTguNDEyNjk4NCwzNC4yODU3MTQzIDE0LjkyMDYzNDksMzUuMjM4MDk1MiAxMi4zODA5NTI0LDM1LjIzODA5NTIiIGlkPSJMaW5lIiBzdHJva2U9IiMzRUMwQUQiIHN0cm9rZS13aWR0aD0iMS45MDQ3NjE5IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy44MDk1MjQsIDIuODU3MTQzKSI+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iI0ZGRkZGRiIgY3g9IjUuNzE0Mjg1NzEiIGN5PSI2LjY2NjY2NjY3IiByPSI1LjcxNDI4NTcxIj48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICA8dGV4dCBpZD0iMSIgZm9udC1mYW1pbHk9IkhlbHZldGljYU5ldWUtQm9sZCwgSGVsdmV0aWNhIE5ldWUiIGZvbnQtc2l6ZT0iOS41MjM4MDk1MiIgZm9udC13ZWlnaHQ9ImJvbGQiIGZpbGw9IiNGRjY5NTUiPgogICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iMi44NTcxNDI4NiIgeT0iOSI+MTwvdHNwYW4+CiAgICAgICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC43NjE5MDUsIDE2LjE5MDQ3NikiPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiNGRkZGRkYiIGN4PSI1LjcxNDI4NTcxIiBjeT0iNi42NjY2NjY2NyIgcj0iNS43MTQyODU3MSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgPHRleHQgaWQ9IjIiIGZvbnQtZmFtaWx5PSJIZWx2ZXRpY2FOZXVlLUJvbGQsIEhlbHZldGljYSBOZXVlIiBmb250LXNpemU9IjkuNTIzODA5NTIiIGZvbnQtd2VpZ2h0PSJib2xkIiBmaWxsPSIjRkY2OTU1Ij4KICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjIuODU3MTQyODYiIHk9IjkiPjI8L3RzcGFuPgogICAgICAgICAgICAgICAgICAgIDwvdGV4dD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjcxNDI4NiwgMzAuMDk1MjM4KSI+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iI0ZGRkZGRiIgY3g9IjUuNzE0Mjg1NzEiIGN5PSI2LjA5NTIzODEiIHI9IjUuNzE0Mjg1NzEiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSIzIiBmb250LWZhbWlseT0iSGVsdmV0aWNhTmV1ZS1Cb2xkLCBIZWx2ZXRpY2EgTmV1ZSIgZm9udC1zaXplPSI5LjUyMzgwOTUyIiBmb250LXdlaWdodD0iYm9sZCIgZmlsbD0iI0ZGNjk1NSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSIyLjg1NzE0Mjg2IiB5PSI5Ij4zPC90c3Bhbj4KICAgICAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgFlow as ReactComponent };